module.exports = __webpack_public_path__ + "static/media/fail-btn.af76d0d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sku/fail-btn.png
// module id = 807
// module chunks = 0